export const isApplyNow = () =>
  !!window.location.origin.includes('applynow.finance');
